import React, { FC, PropsWithChildren, SyntheticEvent, useState } from 'react'
import useClipboard from 'react-use-clipboard'

import { IconCopy } from '@avantstay/backoffice-vectors'

import { Tooltip } from '../Tooltip'
import * as S from './CopyableContent.styles'

export interface CopyableContentProps {
  className?: string
  valueToCopy: string
  tooltipDescription: string
  shouldHideValue?: boolean
  shouldHideIcon?: boolean
}

export const CopyableContent: FC<PropsWithChildren<CopyableContentProps>> = ({
  className,
  tooltipDescription,
  valueToCopy,
  children,
  shouldHideValue = false,
  shouldHideIcon = false,
}) => {
  const setCopied = useClipboard(valueToCopy)[1]
  const [showCopied, setShowCopied] = useState(false)

  const handleOnClick = (event: SyntheticEvent) => {
    event.stopPropagation()
    event.preventDefault()
    setCopied()
    setShowCopied(true)
    setTimeout(() => setShowCopied(false), 2000)
  }

  return (
    <S.Content className={className}>
      {shouldHideValue || shouldHideIcon ? null : children || valueToCopy}
      <Tooltip
        hideOnClick={false}
        placement="top"
        content={
          showCopied ? `${tooltipDescription} copied` : `Click to copy ${tooltipDescription}`
        }
      >
        {shouldHideIcon ? (
          <S.ChildWrapper onClick={handleOnClick}>{children}</S.ChildWrapper>
        ) : (
          <IconCopy onClick={handleOnClick} />
        )}
      </Tooltip>
    </S.Content>
  )
}
